import React, { useState } from 'react';
import {
  Box, Typography, Paper, TextField, Chip, IconButton, Table, TableHead,
  TableRow, TableCell, TableBody, TableContainer, Collapse, InputAdornment,
  MenuItem, Select, FormControl, InputLabel, Tooltip, Badge,
} from '@mui/material';
import {
  Edit as EditIcon, PlayArrow as PlayIcon, Visibility as WatchIcon,
  Schedule as ScheduleIcon, History as HistoryIcon, Search as SearchIcon,
  KeyboardArrowDown as ExpandIcon, KeyboardArrowUp as CollapseIcon,
  CheckCircle as PassIcon, Cancel as FailIcon,
  FiberManualRecord as DotIcon,
} from '@mui/icons-material';

const TYPE_COLORS = {
  login: { bg: '#e3f2fd', color: '#1565c0', label: 'Login' },
  progress: { bg: '#e8f5e9', color: '#2e7d32', label: 'Progress' },
  roster: { bg: '#fff3e0', color: '#e65100', label: 'Roster' },
  'de-roster': { bg: '#fce4ec', color: '#c62828', label: 'De-roster' },
  'account-creation': { bg: '#f3e5f5', color: '#6a1b9a', label: 'Account Creation' },
};

const STATUS_ICONS = {
  passed: <DotIcon sx={{ color: '#4caf50', fontSize: 14 }} />,
  failed: <DotIcon sx={{ color: '#f44336', fontSize: 14 }} />,
  never: <DotIcon sx={{ color: '#bdbdbd', fontSize: 14 }} />,
};

const MOCK_SCRIPTS = [
  {
    id: 1, appKey: 'khan', appName: 'Khan Academy', name: 'Khan Academy Login',
    type: 'login', execMode: 'Frontend', version: '2.4', lastStatus: 'passed',
    lastRun: '2026-04-09 08:32',
    executions: [
      { id: 101, date: '2026-04-09 08:32', status: 'passed', duration: '4.2s', credential: 'student.jmart @ fivekeys', steps: '7/7' },
      { id: 102, date: '2026-04-08 14:15', status: 'passed', duration: '3.8s', credential: 'test1user2 @ fivekeys', steps: '7/7' },
      { id: 103, date: '2026-04-07 09:01', status: 'failed', duration: '12.1s', credential: 'test5user1 @ riverside', steps: '3/7' },
      { id: 104, date: '2026-04-06 16:45', status: 'passed', duration: '4.0s', credential: 'demo_student @ sandi', steps: '7/7' },
      { id: 105, date: '2026-04-05 11:20', status: 'passed', duration: '3.9s', credential: 'test2user4 @ fivekeys', steps: '7/7' },
    ],
  },
  {
    id: 2, appKey: 'khan', appName: 'Khan Academy', name: 'Khan Academy Progress Collection',
    type: 'progress', execMode: 'Backend', version: '1.2', lastStatus: 'passed',
    lastRun: '2026-04-09 02:00',
    executions: [
      { id: 201, date: '2026-04-09 02:00', status: 'passed', duration: '18.5s', credential: 'teacher_fivekeys', steps: '12/12' },
      { id: 202, date: '2026-04-08 02:00', status: 'passed', duration: '17.9s', credential: 'teacher_fivekeys', steps: '12/12' },
    ],
  },
  {
    id: 3, appKey: 'khan', appName: 'Khan Academy', name: 'Khan Academy Roster Students',
    type: 'roster', execMode: 'Frontend', version: '1.0', lastStatus: 'never',
    lastRun: null,
    executions: [],
  },
  {
    id: 4, appKey: 'khan', appName: 'Khan Academy', name: 'Khan Academy De-roster Students',
    type: 'de-roster', execMode: 'Frontend', version: '0.9', lastStatus: 'never',
    lastRun: null,
    executions: [],
  },
  {
    id: 5, appKey: 'readtheory', appName: 'ReadTheory', name: 'ReadTheory Login',
    type: 'login', execMode: 'Frontend', version: '3.1', lastStatus: 'passed',
    lastRun: '2026-04-09 07:45',
    executions: [
      { id: 501, date: '2026-04-09 07:45', status: 'passed', duration: '3.1s', credential: 'student_demo @ fivekeys', steps: '6/6' },
      { id: 502, date: '2026-04-08 15:30', status: 'passed', duration: '2.9s', credential: 'student_demo @ riverside', steps: '6/6' },
      { id: 503, date: '2026-04-07 10:12', status: 'failed', duration: '8.4s', credential: 'test_user1 @ sandi', steps: '4/6' },
    ],
  },
  {
    id: 6, appKey: 'readtheory', appName: 'ReadTheory', name: 'ReadTheory Progress Collection',
    type: 'progress', execMode: 'Backend', version: '2.0', lastStatus: 'passed',
    lastRun: '2026-04-09 02:00',
    executions: [
      { id: 601, date: '2026-04-09 02:00', status: 'passed', duration: '22.3s', credential: 'teacher_auto @ fivekeys', steps: '9/9' },
    ],
  },
  {
    id: 7, appKey: 'icivics', appName: 'iCivics', name: 'iCivics Login',
    type: 'login', execMode: 'Frontend', version: '1.5', lastStatus: 'failed',
    lastRun: '2026-04-08 16:20',
    executions: [
      { id: 701, date: '2026-04-08 16:20', status: 'failed', duration: '15.0s', credential: 'student1 @ fivekeys', steps: '2/5' },
      { id: 702, date: '2026-04-07 09:50', status: 'passed', duration: '4.5s', credential: 'student1 @ fivekeys', steps: '5/5' },
    ],
  },
  {
    id: 8, appKey: 'careersafe', appName: 'CareerSafe', name: 'CareerSafe Login',
    type: 'login', execMode: 'Frontend', version: '1.1', lastStatus: 'passed',
    lastRun: '2026-04-09 09:10',
    executions: [
      { id: 801, date: '2026-04-09 09:10', status: 'passed', duration: '5.2s', credential: 'cs_student1 @ fivekeys', steps: '8/8' },
      { id: 802, date: '2026-04-08 11:30', status: 'passed', duration: '5.0s', credential: 'cs_student2 @ riverside', steps: '8/8' },
    ],
  },
];

const FILTER_TYPES = ['All', 'Login', 'Progress', 'Roster', 'De-roster'];
const APP_FILTERS = ['All Apps', 'Khan Academy', 'ReadTheory', 'iCivics', 'CareerSafe'];

const ScriptsListMockup = () => {
  const [search, setSearch] = useState('');
  const [typeFilter, setTypeFilter] = useState('All');
  const [appFilter, setAppFilter] = useState('All Apps');
  const [expandedRow, setExpandedRow] = useState(null);

  const filteredScripts = MOCK_SCRIPTS.filter(s => {
    if (search && !s.name.toLowerCase().includes(search.toLowerCase())) return false;
    if (typeFilter !== 'All' && s.type !== typeFilter.toLowerCase().replace('-', '-')) {
      const mapped = { 'Login': 'login', 'Progress': 'progress', 'Roster': 'roster', 'De-roster': 'de-roster' };
      if (mapped[typeFilter] && s.type !== mapped[typeFilter]) return false;
    }
    if (appFilter !== 'All Apps' && s.appName !== appFilter) return false;
    return true;
  });

  // Group by app
  const grouped = {};
  filteredScripts.forEach(s => {
    if (!grouped[s.appKey]) grouped[s.appKey] = { appName: s.appName, scripts: [] };
    grouped[s.appKey].scripts.push(s);
  });

  return (
    <Box>
      {/* Header */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h4" fontWeight={700}>Scripts</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <TextField
            size="small"
            placeholder="Search scripts..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            InputProps={{
              startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment>,
            }}
            sx={{ width: 260 }}
          />
          <FormControl size="small" sx={{ minWidth: 160 }}>
            <InputLabel>App</InputLabel>
            <Select value={appFilter} label="App" onChange={e => setAppFilter(e.target.value)}>
              {APP_FILTERS.map(a => <MenuItem key={a} value={a}>{a}</MenuItem>)}
            </Select>
          </FormControl>
        </Box>
      </Box>

      {/* Type filter chips */}
      <Box sx={{ display: 'flex', gap: 1, mb: 3 }}>
        {FILTER_TYPES.map(t => (
          <Chip
            key={t}
            label={t}
            variant={typeFilter === t ? 'filled' : 'outlined'}
            color={typeFilter === t ? 'primary' : 'default'}
            onClick={() => setTypeFilter(t)}
            sx={{ fontWeight: typeFilter === t ? 700 : 400 }}
          />
        ))}
      </Box>

      {/* Script groups */}
      {Object.entries(grouped).map(([appKey, group]) => (
        <Paper key={appKey} sx={{ mb: 3, overflow: 'hidden' }} elevation={2}>
          <Box sx={{ bgcolor: '#f5f5f5', px: 2, py: 1.5, borderBottom: '1px solid #e0e0e0' }}>
            <Typography variant="subtitle1" fontWeight={700} sx={{ textTransform: 'capitalize' }}>
              {group.appName}
              <Chip label={`${group.scripts.length} scripts`} size="small" sx={{ ml: 1.5 }} />
            </Typography>
          </Box>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell width={40} />
                  <TableCell sx={{ fontWeight: 700 }}>Script Name</TableCell>
                  <TableCell sx={{ fontWeight: 700 }} align="center">Type</TableCell>
                  <TableCell sx={{ fontWeight: 700 }} align="center">Mode</TableCell>
                  <TableCell sx={{ fontWeight: 700 }} align="center">Version</TableCell>
                  <TableCell sx={{ fontWeight: 700 }} align="center">Last Run</TableCell>
                  <TableCell sx={{ fontWeight: 700 }} align="center">Status</TableCell>
                  <TableCell sx={{ fontWeight: 700 }} align="right">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {group.scripts.map(script => {
                  const tc = TYPE_COLORS[script.type] || TYPE_COLORS.login;
                  const isExpanded = expandedRow === script.id;
                  return (
                    <React.Fragment key={script.id}>
                      <TableRow
                        hover
                        sx={{ cursor: 'pointer', '& > *': { borderBottom: isExpanded ? 'none' : undefined } }}
                        onClick={() => setExpandedRow(isExpanded ? null : script.id)}
                      >
                        <TableCell>
                          <IconButton size="small">
                            {isExpanded ? <CollapseIcon /> : <ExpandIcon />}
                          </IconButton>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" fontWeight={600}>{script.name}</Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Chip
                            label={tc.label}
                            size="small"
                            sx={{ bgcolor: tc.bg, color: tc.color, fontWeight: 600, fontSize: '0.75rem' }}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Chip
                            label={script.execMode}
                            size="small"
                            variant={script.execMode === 'Frontend' ? 'outlined' : 'filled'}
                            color={script.execMode === 'Backend' ? 'primary' : 'default'}
                            sx={{ fontSize: '0.7rem', height: 22 }}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Badge color="info" badgeContent={`v${script.version}`}
                            sx={{ '& .MuiBadge-badge': { position: 'relative', transform: 'none', fontSize: '0.7rem' } }}
                          >
                            <span />
                          </Badge>
                        </TableCell>
                        <TableCell align="center">
                          <Typography variant="caption" color="text.secondary">
                            {script.lastRun || 'Never'}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                            {STATUS_ICONS[script.lastStatus]}
                            <Typography variant="caption" sx={{ textTransform: 'capitalize' }}>
                              {script.lastStatus}
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell align="right">
                          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 0 }} onClick={e => e.stopPropagation()}>
                            <Tooltip title="Edit"><IconButton size="small"><EditIcon fontSize="small" /></IconButton></Tooltip>
                            <Tooltip title="Run in Extension"><IconButton size="small" color="success"><PlayIcon fontSize="small" /></IconButton></Tooltip>
                            <Tooltip title="Watch Mode"><IconButton size="small" color="info"><WatchIcon fontSize="small" /></IconButton></Tooltip>
                            <Tooltip title="Schedule"><IconButton size="small"><ScheduleIcon fontSize="small" /></IconButton></Tooltip>
                            <Tooltip title="History"><IconButton size="small"><HistoryIcon fontSize="small" /></IconButton></Tooltip>
                          </Box>
                        </TableCell>
                      </TableRow>

                      {/* Expanded execution history */}
                      <TableRow>
                        <TableCell colSpan={8} sx={{ py: 0, px: 0 }}>
                          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                            <Box sx={{ px: 4, py: 2, bgcolor: '#fafafa' }}>
                              <Typography variant="subtitle2" gutterBottom fontWeight={600}>
                                Recent Executions
                              </Typography>
                              {script.executions.length === 0 ? (
                                <Typography variant="body2" color="text.secondary">No executions recorded yet.</Typography>
                              ) : (
                                <Table size="small">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell sx={{ fontWeight: 600 }}>Date</TableCell>
                                      <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
                                      <TableCell sx={{ fontWeight: 600 }}>Duration</TableCell>
                                      <TableCell sx={{ fontWeight: 600 }}>Credential</TableCell>
                                      <TableCell sx={{ fontWeight: 600 }}>Steps</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {script.executions.map(exec => (
                                      <TableRow key={exec.id}>
                                        <TableCell><Typography variant="caption">{exec.date}</Typography></TableCell>
                                        <TableCell>
                                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                            {exec.status === 'passed' ? <PassIcon sx={{ color: '#4caf50', fontSize: 16 }} /> : <FailIcon sx={{ color: '#f44336', fontSize: 16 }} />}
                                            <Typography variant="caption" sx={{ textTransform: 'capitalize' }}>{exec.status}</Typography>
                                          </Box>
                                        </TableCell>
                                        <TableCell><Typography variant="caption">{exec.duration}</Typography></TableCell>
                                        <TableCell><Typography variant="caption" sx={{ fontFamily: 'monospace' }}>{exec.credential}</Typography></TableCell>
                                        <TableCell><Typography variant="caption">{exec.steps}</Typography></TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              )}
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      ))}

      {/* Summary footer */}
      <Box sx={{ display: 'flex', gap: 3, mt: 2, color: 'text.secondary' }}>
        <Typography variant="body2">{filteredScripts.length} scripts shown</Typography>
        <Typography variant="body2">{filteredScripts.filter(s => s.lastStatus === 'passed').length} passing</Typography>
        <Typography variant="body2">{filteredScripts.filter(s => s.lastStatus === 'failed').length} failing</Typography>
        <Typography variant="body2">{filteredScripts.filter(s => s.lastStatus === 'never').length} never run</Typography>
      </Box>
    </Box>
  );
};

export default ScriptsListMockup;
